import { render, staticRenderFns } from "./relatedReading.vue?vue&type=template&id=5ff91afa&scoped=true&"
import script from "./relatedReading.vue?vue&type=script&lang=js&"
export * from "./relatedReading.vue?vue&type=script&lang=js&"
import style0 from "./relatedReading.vue?vue&type=style&index=0&id=5ff91afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff91afa",
  null
  
)

export default component.exports